import { IntlMessageID } from "~/providers/I18nProvider";

export const ChangePasswordError: Record<
  string,
  { message: IntlMessageID; description?: IntlMessageID }
> = {
  //Keys come from backend
  UserNamePasswordError: {
    message: "ChangePassword.Error.UserNamePasswordError.Message",
  },
  OnlyExpiredUserPassword: {
    message: "ChangePassword.Error.OnlyExpiredUserPassword.Message",
  },
  UserLocked: {
    message: "ChangePassword.Error.UserLocked.Message",
  },
};
